import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Prismic from 'prismic-javascript';
import MetaTags from 'react-meta-tags';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Breadcrumbs from '../../components/breadcrumbs';
import Block from './block';
import Unidades from './units';
import History from './history';
import Bar from './bar';

import LanguageContext from '../../context/LangContext';

class AGuararapes extends Component {
  state = {
    content: {},
    language: '',
    section: '',
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({section: this.props.match.params.section, language: language});
    this.getContent();
    this.getScroll();
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (
      this.props.match.params.section !== this.state.section ||
      this.state.language !== language
    ) {
      window.scrollTo(0, 0)
      this.setState({section: this.props.match.params.section, language: language});
      this.getContent();
      this.getScroll();
    }
  }

  getContent = () => {
    const { language } = this.context;
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);

    const fetchContent = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'sobre'),
        {lang: language}
      )
      if (response) {
        this.setState({content: response.results[0].data});

        this.getScroll();
      }
    }
    fetchContent();
    this.getScroll();
  }

  getScroll = () => {
    if (this.state.section !== '' && document.querySelector(`#${this.props.match.params.section}`)) {
      window.scrollTo(0, document.querySelector(`#${this.props.match.params.section}`).offsetTop - 148)
    }
  }

  render = () => {
    const { language } = this.context;
    let home = ''
    let about = ''
    switch (language) {
      case 'pt-br':
        home = 'Inicio';
        about = 'A Guararapes';
        break;
      case 'en-us':
        home = 'Home';
        about = 'About us';
        break;
      case 'es-es':
        home = 'Inicio';
        about = 'A Guararapes';
        break;
      default:
    }
    return (
      <div id="a-guararapes">
        <MetaTags>
          <title>{ this.state.content.meta_title }</title>
          <meta id="meta-description" name="description" content={ this.state.content.meta_description } />
          <meta id="og-title" property="og:title" content={ this.state.content.meta_title } />
        </MetaTags>
        <Header />
        <Breadcrumbs title={ about } link="/">
          <div>
            <Link to="/">{ home }</Link>
            <Link to="/a-guararapes">{ about }</Link>
          </div>
        </Breadcrumbs>
        <Bar tabs={ this.state.content.tabs } />
        <main id="content">
          {
            this.state.content.body && this.state.content.body.map((item, index) => {
              switch (item.slice_type) {
                case "sessao_conteudo":
                  return (
                    <Block key={ index } index={ index } {...item.primary} />
                  )
                case "sessao_historia":
                  return (
                    <History key={ index } {...item.primary} items={ item.items } />
                  )
                case "sessao_unidades":
                  return (
                    <Unidades key={ index } {...item.primary} items={ item.items } />
                  )
                default:
              }
              return true;
            })
          }
        </main>
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

AGuararapes.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
  context: PropTypes.object,
};

AGuararapes.contextType = LanguageContext;

export default AGuararapes;
